import { oktaAxios } from "@/vue/api/config";

const baseUrl = "v1/transcription";

export const getTranscript = (formData) => {
  return oktaAxios.post(`${baseUrl}/transcribe`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getSummary = (transcript) => {
  return oktaAxios.post(`${baseUrl}/summarise`, transcript);
};
